// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__4odSy","left":"InfoRow_left__113Ut"};